export default __webpack_public_path__ + "static/countdown_widget_expanded-97f60f22f3438206c1a1dbdf2a2a8841.png";